import React, { memo } from 'react'
import { Grid2 } from '@mui/material'

import PageTitle from '../shared/pageTitle/PageTitle'
import AppWelcome from './AppWelcome'
import WhatArePoints from './WhatArePoints'
import GetStaking from './GetStaking'
import PointsSummary from './PointsSummary'
import StakingSummary from './StakingSummary'
import AppFeatured from './AppFeatured'
import MainBanner from '../mainBanner/MainBanner'

const Overview = ({
  isQuestsEnabled,
  firstName,
  t,
  symbol,
  receiveRewardCard,
  mainProfile
}) => {
  return (
    <>
      <PageTitle
        customTitle={t('navigation.home')}
        title={<>{t('home.welcome-back-user', { firstName })} 👑</>}
      />
      <Grid2 container spacing={3}>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <PointsSummary t={t} mainProfile={mainProfile} symbol={symbol} />
        </Grid2>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <StakingSummary t={t} />
        </Grid2>
        <Grid2 size={{ xs: 12, md: 8 }}>
          <AppWelcome
            title={t('home.quick-navigation')}
            description={t('brand:home.quick-navigation-desc')}
            img={<MainBanner />}
            isQuestsEnabled={isQuestsEnabled}
            mainProfile={mainProfile}
            symbol={symbol}
            t={t}
          />
        </Grid2>
        <Grid2 size={{ xs: 12, md: 4 }}>
          <AppFeatured t={t} />
        </Grid2>
        <Grid2 size={{ xs: 12, md: 4 }}>{receiveRewardCard()}</Grid2>
        <Grid2 size={{ xs: 12, md: 4 }}>
          <WhatArePoints symbol={symbol} t={t} />
        </Grid2>
        <Grid2 size={{ xs: 12, md: 4 }}>
          <GetStaking t={t} />
        </Grid2>
      </Grid2>
    </>
  )
}

export default memo(Overview)
